export default "__VITE_ASSET__Dr_O7Diw__"